<template lang="pug">
  .card-gallery(ref="gallery")
    Portal(to="photoswipe" )
      v-photoswipe(:isOpen="isPhotoSwipeOpen" :options="options" :items="images" @close="hidePhotoSwipe")

    .card-gallery__images(ref='images')
      .card-gallery__image(v-for="image in images")
        img(:src="image.thumbnail" alt="picture" @click="showPhotoSwipe(0)")

    .card-gallery__controls(v-if="images.length > 1")
      .card-gallery__button(v-for="(image, i) in images" :key="i" @click="showPhotoSwipe(i)" @mouseover="showImage(i)")
</template>

<script>
import PhotoSwipe from "./photoswipe.vue";
import {Portal} from 'portal-vue'

export default {
  components: {
    Portal,
    'v-photoswipe': PhotoSwipe,
  },
  props: ["images"],
  data() {
    return {
      isPhotoSwipeOpen: false,
    };
  },
  computed: {
    options() {
      return {
        index: 0,
        shareEl: false,
        closeOnScroll: false,
        getThumbBoundsFn: () => {
          const pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop;
          const rect = this.$refs.gallery.getBoundingClientRect();
          return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
        },
      };
    },
  },
  methods: {
    showPhotoSwipe(index) {
      this.isPhotoSwipeOpen = true;
      this.$set(this.options, "index", index);
    },

    hidePhotoSwipe() {
      this.isPhotoSwipeOpen = false;
    },

    showImage(index) {
      if (!this.$refs.images) {
        return
      }
      this.$refs.images.children.forEach((element) => {
        if (element.classList.contains("show")) {
          element.style.zIndex = 1;
          element.classList.remove("show");
        } else {
          element.style.zIndex = 0;
        }
      });
      this.$refs.images.children[index].style.zIndex = 2;
      this.$refs.images.children[index].classList.add("show");
    },
  },
};
</script>
